import { capitalizeFirstLetter } from '@/helpers/capitalizeFirstLetter'
import { FilterType, MileageLossCode, DailyLogCode, Code } from '@/types/logs'
import { FilterOption } from '@/ui/Table/ui/components/CommonHeader'

const mileageLossValues = Object.values(MileageLossCode).sort()
const dailyLogValues = Object.values(DailyLogCode).sort()
const CODES_ORDER: string[] = [...mileageLossValues, ...dailyLogValues]

export const formatCodeFilterValues = (values: string[], filter: FilterType, codes: Code[]): FilterOption[] => {
    // Determine which codes to include based on the filter
    let allowedCodes: string[]

    switch (filter) {
        case FilterType.DailyLog:
            allowedCodes = dailyLogValues
            break
        case FilterType.MileageLoss:
            allowedCodes = mileageLossValues
            break
        case FilterType.All:
        default:
            allowedCodes = CODES_ORDER
            break
    }

    const filteredValues = values.filter((code) => {
        return filter === FilterType.All || allowedCodes.includes(code)
    })

    const known: string[] = []
    const unknown: string[] = []

    for (const val of filteredValues) {
        if (CODES_ORDER.includes(val)) {
            known.push(val)
        } else {
            unknown.push(val)
        }
    }

    known.sort((a, b) => CODES_ORDER.indexOf(a) - CODES_ORDER.indexOf(b))
    unknown.sort()

    // Map codes to their display names
    return [...known, ...unknown]
        .map((code) => {
            const codeObj = codes.find((c) => c.code === code)

            if (codeObj) {
                return {
                    label: codeObj.description,
                    value: code.toLowerCase(),
                }
            }

            // Otherwise, capitalize the first letter (for unknown codes)
            const value = capitalizeFirstLetter(code)
            return {
                label: value,
                value: code.toLowerCase(),
            }
        })
        .sort((a, b) => a.label.localeCompare(b.label))
}
